<template lang='pug'>
  transition
    nav.navs.drawer.component
      slot
</template>

<script>
  import { auth } from '@/main'

  export default {
    name: 'navs.drawer.component',

    props: {
      user: Object,
    },

    data() {
      return {
        open: { left: true, right: false },
        distance: 320,
        scrolled: false
      }
    },

    methods: {
      // sign_out() {
      //   auth.signOut().then( snap => this.$emit('signed-out') )
      //   this.$router.push('/sign-in')
      // },

      // scroll(e) {
      //   if ( e.target.scrollingElement.scrollTop > this.distance )
      //     this.scrolled = true
      //   else
      //     this.scrolled = false
      // },
    },

    mounted() {
      window.addEventListener('scroll', this.scroll)
    }
  }
</script>

<style scoped lang='stylus'>
  .v-leave
    // transform scale(1)
    left -100%
    transition all 999ms

  .v-leave-to
    //

  .v-enter

  .v-enter-to
    //

  .component
    position fixed
    height 100vh
    width var(--width-nav)
    left 0
    top 0
    overflow-y auto
    z-index 2
    transition all 480ms
    box-shadow var(--shadow-box-shallow)
    border-right 2px solid rgba( 0 0 0 .5 )
    background rgb( 20 20 20 )
    box-sizing border-box
    @media( max-width: 800px )
      left -100%
</style>
